export const TOURNAMENT_LIST_REQUEST = 'TOURNAMENT_LIST_REQUEST'
export const TOURNAMENT_LIST_SUCCESS = 'TOURNAMENT_LIST_SUCCESS'
export const TOURNAMENT_LIST_FAIL    = 'TOURNAMENT_LIST_FAIL'

export const TOURNAMENT_DETAILS_REQUEST = 'TOURNAMENT_DETAILS_REQUEST'
export const TOURNAMENT_DETAILS_SUCCESS = 'TOURNAMENT_DETAILS_SUCCESS'
export const TOURNAMENT_DETAILS_FAIL    = 'TOURNAMENT_DETAILS_FAIL'
export const TOURNAMENT_DETAILS_RESET   = 'TOURNAMENT_DETAILS_RESET'

export const TOURNAMENT_CREATE_REQUEST = 'TOURNAMENT_CREATE_REQUEST'
export const TOURNAMENT_CREATE_SUCCESS = 'TOURNAMENT_CREATE_SUCCESS'
export const TOURNAMENT_CREATE_FAIL    = 'TOURNAMENT_CREATE_FAIL'
export const TOURNAMENT_CREATE_RESET   = 'TOURNAMENT_CREATE_RESET'

export const TOURNAMENT_UPDATE_REQUEST = 'TOURNAMENT_UPDATE_REQUEST'
export const TOURNAMENT_UPDATE_SUCCESS = 'TOURNAMENT_UPDATE_SUCCESS'
export const TOURNAMENT_UPDATE_FAIL    = 'TOURNAMENT_UPDATE_FAIL'
export const TOURNAMENT_UPDATE_RESET   = 'TOURNAMENT_UPDATE_RESET'

export const TOURNAMENT_DELETE_REQUEST = 'TOURNAMENT_DELETE_REQUEST'
export const TOURNAMENT_DELETE_SUCCESS = 'TOURNAMENT_DELETE_SUCCESS'
export const TOURNAMENT_DELETE_FAIL    = 'TOURNAMENT_DELETE_FAIL'

export const TOURNAMENT_DAY_CREATE_REQUEST = 'TOURNAMENT_DAY_CREATE_REQUEST'
export const TOURNAMENT_DAY_CREATE_SUCCESS = 'TOURNAMENT_DAY_CREATE_SUCCESS'
export const TOURNAMENT_DAY_CREATE_FAIL    = 'TOURNAMENT_DAY_CREATE_FAIL'
export const TOURNAMENT_DAY_CREATE_RESET   = 'TOURNAMENT_DAY_CREATE_RESET'

export const TOURNAMENT_DAY_UPDATE_REQUEST = 'TOURNAMENT_DAY_UPDATE_REQUEST'
export const TOURNAMENT_DAY_UPDATE_SUCCESS = 'TOURNAMENT_DAY_UPDATE_SUCCESS'
export const TOURNAMENT_DAY_UPDATE_FAIL    = 'TOURNAMENT_DAY_UPDATE_FAIL'
export const TOURNAMENT_DAY_UPDATE_RESET   = 'TOURNAMENT_DAY_UPDATE_RESET'

export const TOURNAMENT_DAY_DELETE_REQUEST = 'TOURNAMENT_DAY_DELETE_REQUEST'
export const TOURNAMENT_DAY_DELETE_SUCCESS = 'TOURNAMENT_DAY_DELETE_SUCCESS'
export const TOURNAMENT_DAY_DELETE_FAIL    = 'TOURNAMENT_DAY_DELETE_FAIL'

export const TOURNAMENT_AWARD_CREATE_REQUEST = 'TOURNAMENT_AWARD_CREATE_REQUEST'
export const TOURNAMENT_AWARD_CREATE_SUCCESS = 'TOURNAMENT_AWARD_CREATE_SUCCESS'
export const TOURNAMENT_AWARD_CREATE_FAIL    = 'TOURNAMENT_AWARD_CREATE_FAIL'
export const TOURNAMENT_AWARD_CREATE_RESET   = 'TOURNAMENT_AWARD_CREATE_RESET'

export const TOURNAMENT_AWARD_DELETE_REQUEST = 'TOURNAMENT_AWARD_DELETE_REQUEST'
export const TOURNAMENT_AWARD_DELETE_SUCCESS = 'TOURNAMENT_AWARD_DELETE_SUCCESS'
export const TOURNAMENT_AWARD_DELETE_FAIL    = 'TOURNAMENT_AWARD_DELETE_FAIL'

export const TOURNAMENT_CONTEST_CREATE_REQUEST = 'TOURNAMENT_CONTEST_CREATE_REQUEST'
export const TOURNAMENT_CONTEST_CREATE_SUCCESS = 'TOURNAMENT_CONTEST_CREATE_SUCCESS'
export const TOURNAMENT_CONTEST_CREATE_FAIL    = 'TOURNAMENT_CONTEST_CREATE_FAIL'
export const TOURNAMENT_CONTEST_CREATE_RESET   = 'TOURNAMENT_CONTEST_CREATE_RESET'

export const TOURNAMENT_CONTEST_DELETE_REQUEST = 'TOURNAMENT_CONTEST_DELETE_REQUEST'
export const TOURNAMENT_CONTEST_DELETE_SUCCESS = 'TOURNAMENT_CONTEST_DELETE_SUCCESS'
export const TOURNAMENT_CONTEST_DELETE_FAIL    = 'TOURNAMENT_CONTEST_DELETE_FAIL'

export const TOURNAMENT_REG_LIST_REQUEST = 'TOURNAMENT_REG_LIST_REQUEST'
export const TOURNAMENT_REG_LIST_SUCCESS = 'TOURNAMENT_REG_LIST_SUCCESS'
export const TOURNAMENT_REG_LIST_FAIL    = 'TOURNAMENT_REG_LIST_FAIL'

export const TOURNAMENT_REG_ADD_REQUEST = 'TOURNAMENT_REG_ADD_REQUEST'
export const TOURNAMENT_REG_ADD_SUCCESS = 'TOURNAMENT_REG_ADD_SUCCESS'
export const TOURNAMENT_REG_ADD_FAIL    = 'TOURNAMENT_REG_ADD_FAIL'
export const TOURNAMENT_REG_ADD_RESET   = 'TOURNAMENT_REG_ADD_RESET'

export const TOURNAMENT_REG_UPDATE_REQUEST = 'TOURNAMENT_REG_UPDATE_REQUEST'
export const TOURNAMENT_REG_UPDATE_SUCCESS = 'TOURNAMENT_REG_UPDATE_SUCCESS'
export const TOURNAMENT_REG_UPDATE_FAIL    = 'TOURNAMENT_REG_UPDATE_FAIL'

export const TOURNAMENT_REG_DELETE_REQUEST = 'TOURNAMENT_REG_DELETE_REQUEST'
export const TOURNAMENT_REG_DELETE_SUCCESS = 'TOURNAMENT_REG_DELETE_SUCCESS'
export const TOURNAMENT_REG_DELETE_FAIL    = 'TOURNAMENT_REG_DELETE_FAIL'

export const TOURNAMENT_TEAMS_LIST_REQUEST = 'TOURNAMENT_TEAMS_LIST_REQUEST'
export const TOURNAMENT_TEAMS_LIST_SUCCESS = 'TOURNAMENT_TEAMS_LIST_SUCCESS'
export const TOURNAMENT_TEAMS_LIST_FAIL    = 'TOURNAMENT_TEAMS_LIST_FAIL'

export const TOURNAMENT_TEAMS_GENERATE_REQUEST = 'TOURNAMENT_TEAMS_GENERATE_REQUEST'
export const TOURNAMENT_TEAMS_GENERATE_SUCCESS = 'TOURNAMENT_TEAMS_GENERATE_SUCCESS'
export const TOURNAMENT_TEAMS_GENERATE_FAIL    = 'TOURNAMENT_TEAMS_GENERATE_FAIL'

export const TOURNAMENT_TEAMS_CLEAR_REQUEST = 'TOURNAMENT_TEAMS_CLEAR_REQUEST'
export const TOURNAMENT_TEAMS_CLEAR_SUCCESS = 'TOURNAMENT_TEAMS_CLEAR_SUCCESS'
export const TOURNAMENT_TEAMS_CLEAR_FAIL    = 'TOURNAMENT_TEAMS_CLEAR_FAIL'

export const TOURNAMENT_TEAM_ADD_REQUEST = 'TOURNAMENT_TEAM_ADD_REQUEST'
export const TOURNAMENT_TEAM_ADD_SUCCESS = 'TOURNAMENT_TEAM_ADD_SUCCESS'
export const TOURNAMENT_TEAM_ADD_FAIL    = 'TOURNAMENT_TEAM_ADD_FAIL'

export const TOURNAMENT_TEAM_MEMBER_ADD_REQUEST = 'TOURNAMENT_TEAM_MEMBER_ADD_REQUEST'
export const TOURNAMENT_TEAM_MEMBER_ADD_SUCCESS = 'TOURNAMENT_TEAM_MEMBER_ADD_SUCCESS'
export const TOURNAMENT_TEAM_MEMBER_ADD_FAIL    = 'TOURNAMENT_TEAM_MEMBER_ADD_FAIL'

export const TOURNAMENT_TEAM_MEMBER_REMOVE_REQUEST = 'TOURNAMENT_TEAM_MEMBER_REMOVE_REQUEST'
export const TOURNAMENT_TEAM_MEMBER_REMOVE_SUCCESS = 'TOURNAMENT_TEAM_MEMBER_REMOVE_SUCCESS'
export const TOURNAMENT_TEAM_MEMBER_REMOVE_FAIL    = 'TOURNAMENT_TEAM_MEMBER_REMOVE_FAIL'

export const TOURNAMENT_AWARD_UPDATE_REQUEST = 'TOURNAMENT_AWARD_UPDATE_REQUEST'
export const TOURNAMENT_AWARD_UPDATE_SUCCESS = 'TOURNAMENT_AWARD_UPDATE_SUCCESS'
export const TOURNAMENT_AWARD_UPDATE_FAIL    = 'TOURNAMENT_AWARD_UPDATE_FAIL'

export const TOURNAMENT_CONTEST_UPDATE_REQUEST = 'TOURNAMENT_CONTEST_UPDATE_REQUEST'
export const TOURNAMENT_CONTEST_UPDATE_SUCCESS = 'TOURNAMENT_CONTEST_UPDATE_SUCCESS'
export const TOURNAMENT_CONTEST_UPDATE_FAIL    = 'TOURNAMENT_CONTEST_UPDATE_FAIL'

export const TOURNAMENT_WINNER_UPDATE_REQUEST = 'TOURNAMENT_WINNER_UPDATE_REQUEST'
export const TOURNAMENT_WINNER_UPDATE_SUCCESS = 'TOURNAMENT_WINNER_UPDATE_SUCCESS'
export const TOURNAMENT_WINNER_UPDATE_FAIL    = 'TOURNAMENT_WINNER_UPDATE_FAIL'
